import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { TextInput } from '@gitbook/spine-react';

import type { ContentKitElementProps } from './types';

export function ContentKitTextInput(
    props: ContentKitElementProps<api.ContentKitTextInput>
): React.ReactElement {
    const { element, localState, setLocalState } = props;

    const value = String(localState[element.state] || element.initialValue || '');

    return (
        <TextInput
            disabled={element.disabled}
            size="medium"
            type={element.inputType}
            value={value}
            onChange={(event) => {
                setLocalState((prev) => ({
                    ...prev,
                    [element.state]: event.target.value,
                }));
            }}
            placeholder={element.placeholder}
            multiline={element.multiline}
        />
    );
}
